import { dateStringSerializer } from "@megaron/date-string";
import { Serializers } from "@megaron/serializers";
import { UriBuilder, UriOfSchema, UriSchema, UriSpec } from "@megaron/uri";
import { uuidSerializer } from "@megaron/uuid";

import { invoiceThreadFiltersSerializer } from "./invoiceThreadFilters";

export const megaraxUriSchema = UriSchema({
  "megarax://home": UriSpec(),

  "megarax://test-doc/{id}": UriSpec({ id: Serializers.string }),
  "megarax://saved-view/{id}": UriSpec({ id: Serializers.string }),

  "megarax://crm/customers": UriSpec(),
  "megarax://crm/customers/new": UriSpec(),
  "megarax://crm/customer-list/{id}": UriSpec({ id: uuidSerializer }),
  "megarax://crm/customer/{id}": UriSpec({ id: uuidSerializer }),

  "megarax://crm/orders": UriSpec(),
  "megarax://crm/order/{number}": UriSpec({ number: Serializers.string }),

  "megarax://crm/order-drafts": UriSpec(),
  "megarax://crm/order-draft/{id}": UriSpec({ id: uuidSerializer }),

  "megarax://crm/my-visits": UriSpec(),
  "megarax://crm/visits/{id}": UriSpec({
    id: Serializers.string,
    view: Serializers.oneOf<"week" | "day">("week", "day"),
    date: dateStringSerializer,
  }),

  "megarax://crm/regions": UriSpec(),
  "megarax://crm/region/{id}": UriSpec({ id: Serializers.string }),

  "megarax://crm/trade-routes": UriSpec(),
  "megarax://crm/trade-route/{id}": UriSpec({ id: uuidSerializer }),

  "megarax://crm/price-reports": UriSpec(),
  "megarax://crm/price-report-products": UriSpec(),

  "megarax://crm/home": UriSpec(),
  "megarax://crm/post-sale-discounts": UriSpec(),
  "megarax://crm/profit-targets": UriSpec(),
  "megarax://crm/my-affiliate-codes": UriSpec(),
  "megarax://crm/product-availability": UriSpec(),
  "megarax://crm/training-calendar": UriSpec(),

  "megarax://catalog/items": UriSpec(),
  "megarax://catalog/item/{id}": UriSpec({ id: Serializers.string }),
  "megarax://catalog/price-lists": UriSpec(),
  "megarax://catalog/price-list/{id}": UriSpec({ id: Serializers.string }),

  "megarax://invoices/thread/{id}": UriSpec({ id: uuidSerializer }),
  "megarax://invoices/threads": UriSpec({
    filters: invoiceThreadFiltersSerializer.asJsonString().optional(),
  }),
  "megarax://invoices/budget/{id}": UriSpec({ id: uuidSerializer }),
  "megarax://invoices/budgets": UriSpec(),
  "megarax://invoices/draft/{id}": UriSpec({ id: uuidSerializer }),
  "megarax://invoices/drafts": UriSpec(),

  "megarax://iam/user/{id}": UriSpec({ id: Serializers.string }),
  "megarax://iam/users": UriSpec(),
  "megarax://iam/group/{id}": UriSpec({ id: uuidSerializer }),
  "megarax://iam/groups": UriSpec(),

  "megarax://support/ticket/{id}": UriSpec({ id: uuidSerializer }),
  "megarax://support/tickets": UriSpec(),

  "megarax://loyalty/lines": UriSpec(),
  "megarax://loyalty/line/{id}": UriSpec({ id: Serializers.string }),
  "megarax://loyalty/batches": UriSpec(),
  "megarax://loyalty/production-batch/{id}": UriSpec({ id: Serializers.string }),
  "megarax://loyalty/label-batch/{id}": UriSpec({ id: Serializers.string }),
  "megarax://loyalty/code-groups": UriSpec(),
  "megarax://loyalty/blik-checks": UriSpec(),
  "megarax://loyalty/accounts": UriSpec(),
  "megarax://loyalty/inspect-code": UriSpec(),
  "megarax://loyalty/carts": UriSpec(),
  "megarax://loyalty/listings": UriSpec(),
  "megarax://loyalty/order-fulfillment": UriSpec(),

  "megarax://support/settings": UriSpec(),

  "megarax://dev/environment": UriSpec(),
  "megarax://dev/notifications": UriSpec(),
  "megarax://dev/docs": UriSpec(),
});

export type MegaraxUriSchema = typeof megaraxUriSchema;
export const MegaraxUri = UriBuilder(megaraxUriSchema);
export type MegaraxUri = UriOfSchema<MegaraxUriSchema>;
